import Vue from 'vue'

import App from './AppNewIARC.vue'
import router from './router'

import axios from 'axios'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import i18n from './i18n.js'
import { Trans } from './plugins/Translation.js'
import MobileDetect from 'mobile-detect'
// global 
import store from '@/subsites/covid/store.js'


Vue.prototype.$i18nRoute = Trans.i18nRoute.bind(Trans)
//Vue.config.productionTip = false;
Vue.config.devtools = true ;

import ConstProject from '@/subsites/covid/const.js'

import TrendsConf from '@/subsites/covid/conf/visualisations/Trends.json'
import SimpleBarsConf from '@/subsites/covid/conf/visualisations/SimpleBars.json'
import TrendsConf3 from '@/subsites/covid/conf/visualisations/Trends-Scenario3.json'
import SimpleBarsConf3 from '@/subsites/covid/conf/visualisations/SimpleBars-Scenario3.json'
import StackedBars from '@/subsites/covid/conf/visualisations/StackedBars.json'
import DashboardConf from '@/subsites/covid/conf/visualisations/Dashboard.json'
import DashboardNewConf from '@/subsites/covid/conf/visualisations/DashboardNew.json'

//import CumulativeDeaths from '@/subsites/covid/assets/data/cumulative-deaths.json'
//import PillarCoverage from '@/subsites/covid/assets/data/pillar-coverage.json'

store.commit('setConst', ConstProject)
store.commit('setConf', {
	trends : TrendsConf , 
	simple_bars : SimpleBarsConf , 
	trends3 : TrendsConf3 , 
	simple_bars3 : SimpleBarsConf3 , 
	stacked_bars : StackedBars , 
	dashboard : DashboardConf , 
	dashboard_new : DashboardNewConf
}) ; 

store.commit('setDevice' , {
	md : new MobileDetect( navigator.userAgent )
})

/*store.commit('setStaticData',{
	cumulative_deaths : CumulativeDeaths , 
	pillar_coverage : []
});*/

var Default = {
	width : 1140 , 
	height : 1683 , 
	width_pie : 764 - 20 ,  
	pie_items : 5 , 
	pie_margin : 50 , 
	registries : [] , 
	third_page : false , 
	extra_registries : '' ,
	title_font_size : ''
} ; 

let url_api 		= process.env.VUE_APP_API  ; 
let base_url_api 	= url_api ;
url_api = url_api.replace('[vdb]',ConstProject.data_version) ; 

let promises 		= [
    // cancer site list 
    axios.get( base_url_api + 'meta/cancers/all/?cache=0' ) ,
    // pops list 
    axios.get( base_url_api + 'meta/populations/all/?cache=0' ) , 

    axios.get( base_url_api + 'meta/scenarios/all/?cache=0' )
] ; 

// pre load cancer one time and commit them to store
axios.all( promises )
 
	.then( axios.spread(( cancers_promise , populations_promise , scenarios_promise ) => {

		// console.info("populations_promise",populations_promise) ; 

		store.commit('setDictionnay', {
			cancers_promise : cancers_promise.data ,
			populations_promise : Object.values(populations_promise.data).map( m => {
				m.label = m.country_label ; 
				m.country = m.country_code ; 
				// m.$isDisabled = true ; 
				// m.grouping = 'ALL 78 LMIC' ;
				return m ; 
			}),
			scenarios_promise : scenarios_promise.data
		}) ;

		new Vue({
		  router,
		  store,
		  i18n,
		  BootstrapVue,
		  render: h => h(App)
		}).$mount('#app')

		Vue.filter('formatRate', function(value) {
			if (value == 'NA') return value ; 
		  	return formatRate(value);
		});

	}))
    // eslint-disable-next-line
    .catch( error => {
        console.error("Error catched",error) ; 
        this.error = true
    })
    .finally(() => {
    })

Vue.filter('formatRate__', function(value) {
  return formatRate__(value);
});

